import { createContext, useContext } from 'react'

import { ListingDecisionsContextValue } from './listing-decisions-context-types'

const ListingDecisionsContext =
  createContext<ListingDecisionsContextValue | null>(null)

/**
 * Reads the listing-decisions context. Throws if used outside the
 * matching provider.
 *
 * @returns {ListingDecisionsContextValue}
 */
const useListingDecisions = (): ListingDecisionsContextValue => {
  const context = useContext(ListingDecisionsContext)

  if (context === null) {
    throw new Error(
      'useListingDecisions must be used within a ListingDecisionsProvider',
    )
  }

  return context
}

export { ListingDecisionsContext, useListingDecisions }
